export const avatarColors = [
  '#FF5733', '#33B5FF', '#FF33A8', '#33FF57', '#FFC300', '#8E44AD',
  '#2ECC71', '#E74C3C', '#3498DB', '#F39C12', '#1ABC9C', '#9B59B6',
  '#34495E', '#D35400', '#7F8C8D', '#27AE60', '#2980B9', '#C0392B',
  '#16A085', '#E67E22', '#95A5A6', '#FF6F61', '#6C5CE7', '#00B894',
  '#FD79A8', '#00CEC9'
];